import React, { PureComponent } from 'react';
import { Checkbox, Drawer } from 'antd';

class ConfigTableColumns extends PureComponent {
  render() {
    let { close, visible, changed, columns } = this.props;

    return (
      <Drawer
        title="Настроить столбцы"
        placement="left"
        width={896}
        onClose={close}
        visible={visible}
      >
        <div className="orders-settings-columns">
          <div className="orders-settings-columns__item">
            <Checkbox name="info" checked={columns.info} onChange={changed}>
              Номер заказа (Наименование)
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox name="view" checked={columns.view} onChange={changed}>
              Вид транспортной услуги
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox name="status" checked={columns.state} onChange={changed}>
              Статус заказа
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="passengers"
              checked={columns.passengers}
              onChange={changed}
            >
              Количество пассажиров
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox name="price" checked={columns.price} onChange={changed}>
              Цена
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="routeLength"
              checked={columns.routeLength}
              onChange={changed}
            >
              Длина маршрута
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="dateApplication"
              checked={columns.dateApplication}
              onChange={changed}
            >
              Дата подачи
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="placeDelivery"
              checked={columns.placeDelivery}
              onChange={changed}
            >
              Место подачи
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox name="driver" checked={columns.driver} onChange={changed}>
              Водитель
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="finalDestination"
              checked={columns.finalDestination}
              onChange={changed}
            >
              Конечный пункт
            </Checkbox>
          </div>
          <div className="orders-settings-columns__item">
            <Checkbox
              name="dateCreation"
              checked={columns.dateCreation}
              onChange={changed}
            >
              Дата создания
            </Checkbox>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default ConfigTableColumns;
